import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import {
  CreateCollectionRequest,
  DeleteCollectionRequest,
  UpdateCollectionRequest,
  ViewAllCollectionsRequest
} from './collection.types';

export const requestCreateCollection =
  createAction<SagaPayload<CreateCollectionRequest, string>['payload']>('request/createCollection');

export const requestViewAllCollections =
  createAction<SagaPayload<ViewAllCollectionsRequest>['payload']>('request/viewAllCollections');

export const requestUpdateCollection =
  createAction<SagaPayload<UpdateCollectionRequest>['payload']>('request/updateCollection');

export const requestDeleteCollection =
  createAction<SagaPayload<DeleteCollectionRequest>['payload']>('request/deleteCollection');
